import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {
  
  baseUrl = environment.baseUrl;
  viewCompanyData: null;
  property_form = new FormGroup({});

  constructor(private http:HttpClient,) {
    const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    this.property_form = new FormGroup({
      id: new FormControl(null),
      property_name: new FormControl('', [Validators.required]),
      property_heading: new FormControl(''),
      property_type: new FormControl('', [Validators.required]),
      checkin_time: new FormControl(''),
      checkout_time: new FormControl(''),
      reception_hours: new FormControl(''),
      total_rooms: new FormControl('', [Validators.min(1)]),
      min_stay: new FormControl('', [Validators.min(1)]),
      time_zone: new FormControl(''),
      currency: new FormControl(''),
      star_rating: new FormControl(''),
      address: new FormControl('', [Validators.required]),
      address2: new FormControl(''),
      country: new FormControl(''),
      state: new FormControl(''),
      city: new FormControl(''),
      post_code: new FormControl('', [Validators.required]),
      phone: new FormControl(''),
      mobile: new FormControl('', [Validators.required]),
      fax: new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.email]),
      website_url: new FormControl('', [Validators.pattern(reg)]),
      booking_email: new FormControl('', [Validators.required, Validators.email]),
    });
   }

  populateForm(rowData: any){
    this.property_form.setValue(_.omit(rowData, 'company_id', 'user_id', 'created_at', 'updated_at'));
  }

  get_our_property() {
    return this.http.get(this.baseUrl + '/get_our_property');
  }

  get_properties() {
    return this.http.get(this.baseUrl + '/get_properties');  
  }

  insert_property_details(formData: any)
  { 
    //console.log(formData);
    return this.http.post(this.baseUrl + '/create_property',{
      property_name : formData.property_name,
      property_heading : formData.property_name,
      property_type : formData.property_type,
      total_rooms : formData.total_rooms,
      checkin_time: formData.checkin_time,
      checkout_time: formData.checkout_time,
      reception_hours: formData.reception_hours,
      min_stay : formData.min_stay,
      time_zone : formData.time_zone,
      currency : formData.currency,
      star_rating : formData.star_rating,
      address : formData.address,
      address2 : formData.address2,
      country : formData.country,
      state : formData.state,
      city : formData.city,
      post_code : formData.post_code,
      phone : formData.phone,
      mobile : formData.mobile,
      fax : formData.fax,
      email : formData.email,
      website_url : formData.website_url,
      booking_email : formData.booking_email,
    });
  }

  update_property_details(formData: any)
  {
    return this.http.post(this.baseUrl + '/update_property',{
      id : formData.id,
      property_name : formData.property_name,
      property_heading : formData.property_name,
      property_type : formData.property_type,
      total_rooms : formData.total_rooms,
      checkin_time: formData.checkin_time,
      checkout_time: formData.checkout_time,
      reception_hours: formData.reception_hours,
      min_stay : formData.min_stay,
      time_zone : formData.time_zone,
      currency : formData.currency,
      star_rating : formData.star_rating,
      address : formData.address,
      address2 : formData.address2,
      country : formData.country,
      state : formData.state,
      city : formData.city,
      post_code : formData.post_code,
      phone : formData.phone,
      mobile : formData.mobile,
      fax : formData.fax,
      email : formData.email,
      website_url : formData.website_url,
      booking_email : formData.booking_email,
    });
  }

}
